"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPlus = exports.IconMinus = void 0;
var React = __importStar(require("react"));
var IconMinus = function () { return React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24" },
    React.createElement("path", { fill: "currentColor", d: "M18.984 12.984h-13.969v-1.969h13.969v1.969z" })); };
exports.IconMinus = IconMinus;
var IconPlus = function () { return React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24" },
    React.createElement("path", { fill: "currentColor", d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" }),
    React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })); };
exports.IconPlus = IconPlus;
//# sourceMappingURL=index.js.map